export default {
  warningMessage: 'Attention: Les opérations sur compte titres, unités de compte, mandat de gestion ou mandat d’arbitrage portent sur des produits potentiellement soumis à de fortes variations et exposent le capital investi de votre enfant.',
  declineInvestment: 'Refuser ces opérations',
}
